function globalCaptchaContinue(e) {
    var country = (CookieService.getCookie('WUCountryCookie_') || 'US').toLowerCase();
    var language = (CookieService.getCookie('WULanguageCookie_') || 'EN').toLowerCase();
    if (e) { window.location.href = window.location.href !== document.referrer ? document.referrer : `/${country}/${language}/home.html`; } else { document.querySelector('#global-captcha-error').classList.remove('d-none'); }
}